<template>
    <div class="stepper-group">
        <div class="stepper-main">
            <div class="stepper-title" :class="['is-' + currentStatus]">
                {{ this.title }}
            </div>
        </div>
        <div class="stepper-head" :class="`is-${currentStatus}`">
            <div class="stepper-line"></div>
            <div class="stepper-icon"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepperItem',
    props: {
        title: String,
        status: String
    },

    data() {
        return {
            index: -1,
            internalStatus: ''
        }
    },

    beforeCreate() {
        this.$parent.steps.push(this)
    },

    beforeDestroy() {
        const steps = this.$parent.steps
        const index = steps.indexOf(this)
        if (index >= 0) {
            steps.splice(index, 1)
        }
    },

    computed: {
        currentStatus() {
            return this.status || this.internalStatus
        }
    },

    methods: {
        updateStatus(activeItem) {
            if (activeItem > this.index) {
                this.internalStatus = this.$parent.finishStatus
            } else if (parseInt(activeItem) === this.index) {
                this.internalStatus = this.$parent.processStatus
            } else {
                this.internalStatus = 'wait'
            }
        }
    },

    mounted() {
        const unwatch = this.$watch('index', (val) => {
            this.$watch('$parent.active', this.updateStatus, { immediate: true })
            this.$watch(
                '$parent.processStatus',
                () => {
                    const activeIndex = this.$parent.active
                    this.updateStatus(activeIndex)
                },
                { immediate: true }
            )
            unwatch()
        })
    }
}
</script>

<style scoped>
.stepper-group {
    position: relative;
    flex-shrink: 1;
    display: inline-block;
    width: 250px;
}

.stepper-head {
    width: 100%;
    position: relative;
    border-color: #d9dee3;
}

.stepper-line {
    position: absolute;
    height: 2px;
    top: 13px;
    left: 0;
    right: 0;
    border: 2px solid;
    border-color: inherit;
}

.stepper-icon {
    position: absolute;
    height: 30px;
    width: 30px;
    right: 0;
    box-sizing: border-box;
    background: #fafafa;
    z-index: 1;
    transition: 0.15s ease-out;
    border-radius: 50%;
    border: 2px solid;
    border-color: inherit;
}

.stepper-head.is-success > .stepper-icon::after {
    content: '';
    position: absolute;
    background-color: #ffa409;
    background-image: url('../../../assets/img/white_arrow.png');
    background-size: cover;
    background-position-x: -3px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    left: -2px;
    top: -2px;
    border: 2px solid;
    border-color: inherit;
}

.stepper-title {
    text-align: center;
}

.stepper-title.is-process {
    font-weight: 600;
}

.is-success {
    border-color: #ffa409;
}
</style>
